import { render } from "./GeoBotFab.vue?vue&type=template&id=13b7a346&scoped=true"
import script from "./GeoBotFab.vue?vue&type=script&lang=js"
export * from "./GeoBotFab.vue?vue&type=script&lang=js"

import "./GeoBotFab.vue?vue&type=style&index=0&id=13b7a346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b7a346"]])

export default __exports__